import React from 'react';
import './Marker.css';

const Marker = (props: any) => {
    const { color, name, id, price } = props;
    return (
      <div>
        <div
          className="pin bounce"
          style={{ backgroundColor: color, cursor: 'pointer' }}
          title={name}
        />
        {/* {price &&
          <div className="storeid">${price} /gal</div>
        } */}
        <div className="pulse" />
      </div>
    );
  };

  export default Marker;